import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import the dist file because the index.js file gives webpack-uglify plugin problems
import mdcAutoInit from '@material/auto-init/dist/mdc.autoInit';

// import components
import LeafletMapConnected from '../containers/LeafletMapConnected';
import SidebarConnected from '../containers/SidebarConnected';
import Lightbox from './Lightbox/Lightbox';
import MapLegendConnnected from '../containers/MapLegendConnected';
import BasemapSelector from './BasemapSelector';

class App extends Component {
  static propTypes = {
    appHeight: PropTypes.number.isRequired,
    appWidth: PropTypes.number.isRequired,
    basemap: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeLightbox: PropTypes.func.isRequired,
    openLightbox: PropTypes.func.isRequired,
    referrer: PropTypes.string,
    payload: PropTypes.shape({}),
    toggleBasemap: PropTypes.func.isRequired,
  };

  static defaultProps = {
    referrer: '',
    payload: {},
  };

  componentDidMount() {
    // set up JS for Material Design
    mdcAutoInit();
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.isOpen !== this.props.isOpen) {
      return true;
    }

    if (nextProps.appHeight !== this.props.appHeight) {
      return true;
    }

    if (nextProps.basemap !== this.props.basemap) {
      return true;
    }

    return false;
  }

  render() {
    const { isOpen, closeLightbox, referrer, payload, basemap, toggleBasemap } = this.props;

    // pass appHeight to Sidebar so that if a browser resize occurs, the LayersList height will be
    // computed again. LayersList height is dependent on whether or not Instructions is opened / closed
    return (
      <div className="App">
        <LeafletMapConnected lat={0} lng={0} zoom={2} />
        <SidebarConnected />
        <Lightbox {...{ isOpen, closeLightbox, referrer, payload }} content={''} />
        <BasemapSelector selected={basemap} handleClick={toggleBasemap} />
        <MapLegendConnnected />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx